var React = require('react');

function TickCircleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","stroke":"#000","strokeWidth":"2","key":0}),React.createElement("polyline",{"stroke":"#000","strokeLinecap":"square","strokeLinejoin":"round","strokeWidth":"2","points":"8 13.72 10.926 16 16 8","key":1})]));
}

TickCircleInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = TickCircleInline;

TickCircleInline.default = TickCircleInline;
